import type { NextWebVitalsMetric } from 'next/app';

import { MyApp } from 'app/MyApp';
import { sendWebVitals } from 'entities/Analytics';

// eslint-disable-next-line import/no-unassigned-import
import '@src/styles/global.scss';

export function reportWebVitals(metrics: NextWebVitalsMetric) {
  sendWebVitals(metrics);
}

export default MyApp;
